import { Paper, Title, Group } from "@mantine/core"

interface PageHeaderProps {
  title: React.ReactNode
  /** Optional breadcrumbs shown above the title */
  breadcrumbs?: React.ReactNode
  /** Actions shown on the right side (buttons, etc.) */
  actions?: React.ReactNode
}

export default function PageHeader({ title, breadcrumbs, actions }: PageHeaderProps) {
  return (
    <Paper withBorder={false} bg="gray.0" p="md" radius={0}>
      {breadcrumbs && <div style={{ marginBottom: "var(--mantine-spacing-sm)" }}>{breadcrumbs}</div>}
      <Group justify="space-between">
        <Title order={3}>{title}</Title>
        {actions && <Group>{actions}</Group>}
      </Group>
    </Paper>
  )
}
